"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";
interface LazyVideoProps {
  src: string;
  poster: string;
  posterAlt: string;
  className?: string;
  videoClassName?: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  playsInline?: boolean;
}
export function LazyVideo(t0) {
  const $ = _c(26);
  const {
    src,
    poster,
    posterAlt,
    className,
    videoClassName,
    autoPlay: t1,
    loop: t2,
    muted: t3,
    playsInline: t4
  } = t0;
  const autoPlay = t1 === undefined ? true : t1;
  const loop = t2 === undefined ? true : t2;
  const muted = t3 === undefined ? true : t3;
  const playsInline = t4 === undefined ? true : t4;
  const containerRef = useRef(null);
  const videoRef = useRef(null);
  const [isInView, setIsInView] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const observer = new IntersectionObserver(t7 => {
        const [entry] = t7;
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      }, {
        rootMargin: "100px",
        threshold: 0
      });
      observer.observe(container);
      return () => observer.disconnect();
    };
    t6 = [];
    $[0] = t5;
    $[1] = t6;
  } else {
    t5 = $[0];
    t6 = $[1];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[2] !== isInView || $[3] !== src) {
    t7 = () => {
      if (isInView && videoRef.current) {
        videoRef.current.src = src;
        videoRef.current.load();
      }
    };
    t8 = [isInView, src];
    $[2] = isInView;
    $[3] = src;
    $[4] = t7;
    $[5] = t8;
  } else {
    t7 = $[4];
    t8 = $[5];
  }
  useEffect(t7, t8);
  let t9;
  if ($[6] !== className) {
    t9 = cn("relative", className);
    $[6] = className;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = isLoaded ? "opacity-0" : "opacity-100";
  let t11;
  if ($[8] !== t10) {
    t11 = cn("object-cover transition-opacity duration-500", t10);
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== poster || $[11] !== posterAlt || $[12] !== t11) {
    t12 = <Image src={poster} alt={posterAlt} fill={true} priority={false} className={t11} />;
    $[10] = poster;
    $[11] = posterAlt;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== autoPlay || $[15] !== isInView || $[16] !== isLoaded || $[17] !== loop || $[18] !== muted || $[19] !== playsInline || $[20] !== videoClassName) {
    t13 = isInView && <video ref={videoRef} autoPlay={autoPlay} loop={loop} muted={muted} playsInline={playsInline} preload="none" onCanPlay={() => setIsLoaded(true)} className={cn("absolute inset-0 w-full h-full transition-opacity duration-500", videoClassName, isLoaded ? "opacity-100" : "opacity-0")} />;
    $[14] = autoPlay;
    $[15] = isInView;
    $[16] = isLoaded;
    $[17] = loop;
    $[18] = muted;
    $[19] = playsInline;
    $[20] = videoClassName;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13 || $[24] !== t9) {
    t14 = <div ref={containerRef} className={t9}>{t12}{t13}</div>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t9;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}